import React from 'react';
import { ThemeContext } from '@ordermentum/ui-shared/utilities/theme';
import {
  HeaderWrapper,
  PageContainer,
  BodyContainer,
  Background,
} from './LoginBase.styles';

type LoginBaseProps = {
  header: React.ReactNode;
  children?: React.ReactNode;
  type?: 'default' | 'magicLink';
};

export const LoginBase = (props: LoginBaseProps) => {
  const { children, header, type } = props;
  return (
    <ThemeContext.Provider value="futuro">
      <Background>
        <HeaderWrapper>
          <PageContainer type={type}>{header}</PageContainer>
        </HeaderWrapper>
        {children && (
          <PageContainer>
            <BodyContainer type={type}>{children}</BodyContainer>
          </PageContainer>
        )}
      </Background>
    </ThemeContext.Provider>
  );
};
